// ABOUTME: Shared helper that captures the current page and opens the feedback modal via redux.
// ABOUTME: Used by both the sidebar feedback circle and the floating balloon trigger.

import { openFeedback } from "../newapi/global/settingsSlice";
import { showToastMessage } from "./toasts";

// Capture the page as the user currently sees it, then open the feedback modal.
// The capture excludes any element marked data-feedback-widget (the triggers + the
// modal), so the screenshot shows the clean page. On failure we still open the
// modal without a screenshot and surface a toast.
export async function captureAndOpenFeedback(dispatch, t) {
    let dataUrl = null;
    try {
        const html2canvas = (await import("html2canvas")).default;
        const rendered = await html2canvas(document.body, {
            ignoreElements: (el) => el.hasAttribute && el.hasAttribute("data-feedback-widget"),
            scale: 1,
            useCORS: true,
            logging: false,
        });
        dataUrl = rendered.toDataURL("image/png");
    } catch (err) {
        showToastMessage("warning", t("feedback_capture_failed"));
    }
    dispatch(openFeedback({ screenshot: dataUrl }));
}
